/**
 * The theme's standard add-to-cart flow (`product-form-component`, used by every
 * `add-to-cart-button` on product and collection pages) only dispatches `CartAddEvent` —
 * it never opens a cart drawer, since the theme's native `cart-drawer-component` is
 * superseded by the Zipify OCU app's slide cart. This module bridges that gap: it listens
 * globally for `CartAddEvent` and, when the add came from the standard product form, opens
 * the cart drawer via `openCartDrawer()` (which clicks the header `<cart-icon>` so OCU opens
 * through its own state-correct path, and falls back to the native drawer / cart page).
 *
 * The bespoke quick-add flows (home slider, collection-card quick-add, quick-add slider)
 * already call `openCartDrawer()` themselves and use other `source` ids, so they are
 * excluded here to avoid opening the drawer twice.
 */
import { openCartDrawer } from '@theme/cart-quick-add';
import { CartAddEvent } from '@theme/events';

document.addEventListener(CartAddEvent.eventName, (event) => {
  const detail = /** @type {CustomEvent} */ (event).detail;

  // `CartAddEvent` shares its name with `CartUpdateEvent` (both are `cart:update`); the
  // `source`/`didError` fields live under `detail.data`. Only react to a successful add
  // from the standard product form.
  if (detail?.data?.didError) return;
  if (detail?.data?.source !== 'product-form-component') return;

  openCartDrawer();
});
